/**
 * Shared constellation layout so nodes and lines match.
 * Organic spiral + ring shape – one core, nodes orbit outward.
 */

const NODES_MOBILE = 10;
const NODES_DESKTOP = 14;

export function getConstellationNodeCount(isMobile: boolean): number {
  return isMobile ? NODES_MOBILE : NODES_DESKTOP;
}

export interface ConstellationNode {
  id: number;
  x: number;
  y: number;
  r: number;
}

export function getConstellationNodes(nodeCount: number): ConstellationNode[] {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  const n = Math.min(Math.max(6, nodeCount), isMobile ? NODES_MOBILE : NODES_DESKTOP);
  const out: ConstellationNode[] = [];
  const cx = 50;
  const cy = 38;
  // Core + spiral arms: one center, rest in two soft arcs
  out.push({ id: 0, x: cx, y: cy, r: 4 });
  for (let i = 1; i < n; i++) {
    const t = (i - 1) / (n - 1);
    const angle = Math.PI * 0.2 + t * Math.PI * 1.4 + Math.sin(i * 0.9) * 0.3;
    const radius = 12 + t * 22 + Math.sin(i * 0.5) * 4;
    out.push({
      id: i,
      x: cx + Math.cos(angle) * radius,
      y: cy + Math.sin(angle) * radius * 0.75,
      r: 2.5 + (i % 2) * 1.2,
    });
  }
  return out;
}

export function getConstellationEdges(nodes: ConstellationNode[]): Array<[number, number]> {
  const e: Array<[number, number]> = [];
  for (let i = 0; i < nodes.length; i++) {
    for (let j = i + 1; j < nodes.length; j++) {
      const a = nodes[i];
      const b = nodes[j];
      const dx = a.x - b.x, dy = a.y - b.y;
      if (dx * dx + dy * dy < 900) e.push([i, j]);
    }
  }
  return e.slice(0, 10);
}
